import { render, staticRenderFns } from "./ApproveVacation.vue?vue&type=template&id=5453247c&scoped=true&lang=pug&"
import script from "./ApproveVacation.vue?vue&type=script&lang=js&"
export * from "./ApproveVacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5453247c",
  null
  
)

export default component.exports